/**
 * @generated SignedSource<<671deb9a19c21bd773b36b2ce913965c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlockID = {
  blockKey?: string | null;
  id?: string | null;
  noteId?: string | null;
};
export type CopyToModalQuery$variables = {
  ids: ReadonlyArray<BlockID>;
};
export type CopyToModalQuery$data = {
  readonly viewer: {
    readonly noteBlocks: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"CopyToModalBlock">;
    }>;
  };
};
export type CopyToModalQuery = {
  response: CopyToModalQuery$data;
  variables: CopyToModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "document",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyToModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "noteBlocks",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CopyToModalBlock"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CopyToModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "noteBlocks",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteBlock",
                "kind": "LinkedField",
                "name": "descendants",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "noteType",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e456aefe788fd737e99d10c5b3e2afc6",
    "id": null,
    "metadata": {},
    "name": "CopyToModalQuery",
    "operationKind": "query",
    "text": "query CopyToModalQuery(\n  $ids: [BlockID!]!\n) {\n  viewer {\n    noteBlocks(ids: $ids) {\n      ...CopyToModalBlock\n      id\n    }\n    id\n  }\n}\n\nfragment CopyToModalBlock on NoteBlock {\n  id\n  type\n  ...QuotedItemBlock\n  descendants {\n    type\n    id\n  }\n}\n\nfragment QuotedItemBlock on NoteBlock {\n  document\n  descendants {\n    document\n    id\n  }\n  note {\n    __typename\n    id\n    noteType\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc748f6ae7e5fffbdbecb088e0af4079";

export default node;
